// extracted by mini-css-extract-plugin
export default {"container":"UserXemDeXuatList_container__N5Wup","table":"UserXemDeXuatList_table__us5RL","note":"UserXemDeXuatList_note__67-nI"};